import styled from 'styled-components/macro';

import { Card } from 'src/components/atoms/Card';

export const StyledCard = styled(Card)`
  & > div {
    padding: 1.5rem;
  }
`;
